export default __webpack_public_path__ + "static/media/XpressGuideV01.436ab94d.pdf";